import { type GlobalMessageHandler } from '@atlassian/eoc-global-context';

import { type WhoIsOnCallMessage, type WhoIsOnCallWidgetMessage } from './types';

const urls = Object.freeze({
	schedules: {
		url: () => `/v1/schedules`,
		user: {
			url: () => `${urls.schedules.url()}/user`,
			timeline: {
				url: () => `${urls.schedules.user.url()}/timeline`,
				export: {
					url: () => `${urls.schedules.user.timeline.url()}/export`,
				},
			},
			userId: {
				url: (
					{ userId } = {
						userId: ':userId',
					},
				) => `${urls.schedules.user.url()}/${userId}`,
			},
		},
		onCalls: {
			url: () => `${urls.schedules.url()}/on-calls`,
		},
		scheduleId: {
			url: (
				{ scheduleId } = {
					scheduleId: ':scheduleId',
				},
			) => `${urls.schedules.url()}/${scheduleId}`,
			timeline: {
				url: (
					{ scheduleId } = {
						scheduleId: ':scheduleId',
					},
				) => `${urls.schedules.scheduleId.url({ scheduleId })}/timeline`,
			},
		},
	},
	wioc: {
		status: {
			url: () => `${urls.schedules.url()}/user/on-calls`,
		},
	},
	teams: {
		url: () => `/v1/teams`,
	},
} as const);

export const SPOTLIGHT_NAMES = {
	firstOverlappingPeriod: 'eoc-who-is-on-call_first_overlapping_period',
};

export const SPOTLIGHT_TOURS = {
	overlappingPeriod: 'eoc-who-is-on-call-overlapping-period',
};

export { urls };

export class WhoIsOnCallHandler implements GlobalMessageHandler<unknown> {
	handler(message: WhoIsOnCallMessage, context?: unknown) {
		throw new Error('Not implemented');
	}
}

export class WhoIsOnCallWidgetHandler implements GlobalMessageHandler<unknown> {
	handler(message: WhoIsOnCallWidgetMessage, context?: unknown) {
		throw new Error('Not implemented');
	}
}
